(ns ^:dev/always bp-clients.tv-app.api.graphql.analytics)

(def screen-requested-query
  "mutation screen_requested ($input: screen_requested_input!) {
    screen_requested (input: $input) {
      success
    }
  }")
